import { useReduxState } from 'hooks';
import { breakpoints } from 'styles';
import { ContentLabel } from 'components/common';

import type { ReactNode } from 'react';

interface Props {
  children: ReactNode;
  items: {
    label: string;
    value: ReactNode;
  }[];
}

const HomePageSettingsModulesModuleFooter = ({ children, items }: Props) => {
  const { theme } = useReduxState();

  return (
    <div className="footer">
      <div className="items">
        {items.map((item) => (
          <ContentLabel
            horizontal={true}
            key={item.label}
            label={item.label}
            spacing={10}
          >
            <div className=" value">{item.value}</div>
          </ContentLabel>
        ))}
      </div>

      <div className="settings">{children}</div>

      <style jsx>{`
        .footer {
          align-items: flex-start;
          border-top: 1px solid ${theme.lightGreyDark};
          display: flex;
          flex-direction: column;
          gap: 20px;
          padding: 15px 20px;
        }
        .items {
          flex-grow: 1;
        }
        .value {
          font-weight: 400;
        }
        @media (min-width: ${breakpoints.small}px) {
          .footer {
            align-items: center;
            flex-direction: row;
          }
        }
      `}</style>
    </div>
  );
};

export default HomePageSettingsModulesModuleFooter;
